import React from 'react'
import Icons from '@atoms/Icons/Icons'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import ScrollToTopButton from '@atoms/ScrollToTopButton/ScrollToTopButton'
import ConditionalWrapper from '@atoms/ConditionalWrapper/ConditionalWrapper'

type FooterLogoProps = {
  iconName: string
  iconWidth: string
  iconHeight?: string
  className?: string
  notClickable?: boolean
  title?: string
}

const FooterLogo = ({
  iconName,
  iconWidth,
  iconHeight,
  className,
  notClickable,
  title
}: FooterLogoProps) => (
  <>
    <div className={className}>
      <ConditionalWrapper
        condition={!notClickable}
        wrapper={(children: any) => (
          <CustomLinkComponent
            colorScheme='whiteAlpha'
            href='/'
            title={title || ''}
          >
            {children}
          </CustomLinkComponent>
        )}
      >
        <Icons
          iconName={iconName}
          color='white'
          height={iconHeight || '36px'}
          width={iconWidth}
        />
      </ConditionalWrapper>
    </div>
    <ScrollToTopButton />
  </>
)

export default FooterLogo
